import { createApi } from "@reduxjs/toolkit/query/react";
import RtkBaseQueryWithReauth from "./RtkBaseQueryWithReauth";
import ApiPath from "./ConstantApi";
import { HelpDataModel } from "./../Helpers/Interfaces/HelpType";
import Config from "../Config";

export const HelpService = createApi({
  reducerPath: "HelpService",
  baseQuery: RtkBaseQueryWithReauth(Config.BASE_URL),
  tagTypes: ["Help"],
  endpoints: (builder) => ({
    getHelpData: builder.query<any, any>({
      query: () => ({
        url: `${ApiPath.helpService}`,
        method: "GET",
      }),
      transformResponse: (response: { data: HelpDataModel }) => response.data,
      providesTags: ["Help"],
    }),

    getHelpDataByCustomer: builder.query<
      any,
      { customerId: string; page: number; pageSize: number }
    >({
      query: ({ customerId, page, pageSize }) => ({
        url: `${ApiPath.getHelpTicketByCustomer}/${customerId}?page=${page}&pageSize=${pageSize}`,
        method: "GET",
      }),
    }),

    /**
     * The orders this customer may raise a query about.
     *
     * The list is produced by the server, not filtered here, because the same
     * rule has to hold for the request that follows -- a dropdown showing
     * seven days does not stop anything naming an older order.
     */
    getRecentOrdersForHelp: builder.query<any[], void>({
      query: () => ({
        url: `${ApiPath.helpRecentOrders}`,
        method: "GET",
      }),
      transformResponse: (response: { data: any[] }) => response?.data || [],
    }),

    saveHelpData: builder.mutation<any, any>({
      query: (body) => ({
        url: `${ApiPath.createHelpTicket}`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["Help"],
    }),

    subscribeNewsLatter: builder.mutation<any, any>({
      query: (body) => ({
        url: `${ApiPath.newsLetter}`,
        method: "POST",
        body: body,
      }),
    }),

    getDynamicFooter: builder.query<void, void>({
      query: () => ({
        url: `${ApiPath.footer}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetHelpDataQuery,
  useSaveHelpDataMutation,
  useSubscribeNewsLatterMutation,
  useGetHelpDataByCustomerQuery,
  useGetRecentOrdersForHelpQuery,
  useLazyGetDynamicFooterQuery,
} = HelpService;
